import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class OrderService {
  constructor(private httpClient: HttpClient) {}

  deleteOrder(orderId: number) {
    return this.httpClient.post('/rl/api/order/delete', { orderId });
  }
}
